exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#alinear[data-v-be7cc9f0] {\n  text-align: justify;\n}\n.h2_title[data-v-be7cc9f0] {\n  font-weight: normal;\n}\n.solicitud-baja-sim__edit[data-v-be7cc9f0] {\n  background-color: rgb(255, 108, 0) !important;\n  border-color: rgb(255, 108, 0) !important;\n}\n.solicitud-baja-sim__edit span[data-v-be7cc9f0] {\n  color: white;\n}\n", ""]);

// exports
